import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function NoStoreSelectionBlock() {
    const { t } = useTranslation('common');
    return (
        <Box sx={{ pb: 3 }} aria-live="polite">
            {t('Please select a store.')}
        </Box>
    );
}

export default NoStoreSelectionBlock;
